(function () {
  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
    });
  }

  function searchUrl(root, query) {
    var url = new URL(root, window.location.origin);
    url.searchParams.set('type', 'product');
    url.searchParams.set('q', query);
    return url.pathname + url.search;
  }

  function money(root, cents) {
    var amount = (Number(cents || 0) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return String(root.dataset.money || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      return key.indexOf('no_decimals') !== -1 ? amount.replace(/\.00$/, '') : amount;
    });
  }

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';

    var input = root.querySelector('[data-a1-ts-search]');
    var filters = root.querySelector('[data-a1-ts-filters]');
    var grid = root.querySelector('[data-a1-ts-grid]');
    var actions = root.querySelector('[data-a1-ts-actions]');
    var status = root.querySelector('[data-a1-ts-status]');
    var selected = root.querySelector('[data-a1-ts-selected]');
    var activeVariation = 'All';
    var showing = 36;
    var records = [];
    var catalogue = [];
    var productCache = {};

    function matchingProducts(record) {
      var name = record.name.toLocaleLowerCase();
      return catalogue.filter(function (product) { return product[1].toLocaleLowerCase().indexOf(name) !== -1; });
    }

    function product(handle) {
      if (!productCache[handle]) {
        productCache[handle] = fetch(root.dataset.rootUrl.replace(/\/?$/, '/') + 'products/' + handle + '.js')
          .then(function (response) { return response.ok ? response.json() : null; })
          .catch(function () { return null; });
      }
      return productCache[handle];
    }

    function renderProductCards(container, products) {
      if (!products.length) return;
      container.innerHTML = '<h3>Available in this tartan</h3><div class="a1-ts__products" data-a1-ts-products></div>';
      var grid = container.querySelector('[data-a1-ts-products]');
      products.slice(0, 4).forEach(function (entry) {
        var handle = entry[0];
        var card = document.createElement('a');
        card.className = 'a1-ts__product a1-ts__product--loading';
        card.href = root.dataset.rootUrl.replace(/\/?$/, '/') + 'products/' + handle;
        card.innerHTML = '<span class="a1-ts__product-image"></span><span class="a1-ts__product-title">' + escapeHtml(entry[1]) + '</span><span class="a1-ts__product-price"></span>';
        grid.appendChild(card);
        product(handle).then(function (item) {
          if (!item) { card.classList.remove('a1-ts__product--loading'); return; }
          card.classList.remove('a1-ts__product--loading');
          if (item.featured_image) {
            var image = item.featured_image.indexOf('//') === 0 ? 'https:' + item.featured_image : item.featured_image;
            card.querySelector('.a1-ts__product-image').innerHTML = '<img loading="lazy" alt="" src="' + escapeHtml(image) + '">';
          }
          var price = money(root, item.price);
          if (item.compare_at_price > item.price) price += '<s>' + money(root, item.compare_at_price) + '</s>';
          card.querySelector('.a1-ts__product-price').innerHTML = price;
        });
      });
    }

    function filtered() {
      var query = input.value.trim().toLocaleLowerCase();
      return records.filter(function (record) {
        return (!query || record.name.toLocaleLowerCase().indexOf(query) !== -1) &&
          (activeVariation === 'All' || record.variation === activeVariation);
      });
    }

    function select(record) {
      var products = matchingProducts(record);
      selected.hidden = false;
      selected.innerHTML = '<img src="' + escapeHtml(record.asset) + '" alt="' + escapeHtml(record.name) + ' tartan swatch">' +
        '<div class="a1-ts__selected-copy"><p class="a1-ts__eyebrow">Tartan selected</p><h2>' + escapeHtml(record.name) + '</h2>' +
        '<p>Explore the tartan clothing already available in this pattern.</p>' +
        '<div class="a1-ts__selected-actions"><a href="' + escapeHtml(searchUrl(root.dataset.searchUrl, record.name + ' tartan kilt')) + '">Shop tartan kilts</a>' +
        '<a href="' + escapeHtml(searchUrl(root.dataset.searchUrl, record.name + ' tartan')) + '">View all matching products</a></div><div class="a1-ts__product-results" data-a1-ts-product-results></div></div>';
      renderProductCards(selected.querySelector('[data-a1-ts-product-results]'), products);
      selected.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    function render() {
      var matches = filtered();
      status.textContent = matches.length + ' tartan' + (matches.length === 1 ? '' : 's') + ' found';
      grid.innerHTML = matches.slice(0, showing).map(function (record) {
        return '<button class="a1-ts__card" type="button" data-id="' + escapeHtml(record.id) + '">' +
          '<img loading="lazy" src="' + escapeHtml(record.asset) + '" alt="' + escapeHtml(record.name) + ' tartan swatch">' +
          '<span>' + escapeHtml(record.name) + '</span></button>';
      }).join('');
      grid.querySelectorAll('[data-id]').forEach(function (button) {
        button.addEventListener('click', function () {
          select(records.find(function (record) { return record.id === button.dataset.id; }));
        });
      });
      actions.innerHTML = matches.length > showing ? '<button type="button">Show more tartans</button>' : '';
      var more = actions.querySelector('button');
      if (more) more.addEventListener('click', function () { showing += 36; render(); });
    }

    function renderFilters() {
      var variations = ['All'].concat(Array.from(new Set(records.map(function (record) { return record.variation; }).filter(Boolean))).sort());
      filters.innerHTML = variations.map(function (variation) {
        return '<button type="button" aria-pressed="' + (variation === activeVariation) + '" data-variation="' + escapeHtml(variation) + '">' + escapeHtml(variation) + '</button>';
      }).join('');
      filters.querySelectorAll('button').forEach(function (button) {
        button.addEventListener('click', function () {
          activeVariation = button.dataset.variation;
          showing = 36;
          renderFilters();
          render();
        });
      });
    }

    input.addEventListener('input', function () { showing = 36; render(); });
    root.querySelectorAll('[data-a1-ts-popular]').forEach(function (button) {
      button.addEventListener('click', function () { input.value = button.dataset.a1TsPopular; input.dispatchEvent(new Event('input')); input.focus(); });
    });

    Promise.all([fetch(root.dataset.src), fetch(root.dataset.catalogSrc)]).then(function (responses) {
      if (!responses[0].ok || !responses[1].ok) throw new Error('Unable to load tartans');
      return Promise.all(responses.map(function (response) { return response.json(); }));
    }).then(function (data) {
      var library = data[0];
      catalogue = data[1].p || [];
      records = library.records.filter(function (record) { return record.status === 'ready'; }).map(function (record) {
        var asset = root.dataset.assetTemplate.replace(/a1-tartan-little\.jpg(?:\?.*)?$/, record.plannedAsset);
        return Object.assign({}, record, { asset: asset });
      });
      records.sort(function (left, right) { return left.name.localeCompare(right.name); });
      renderFilters();
      render();
      var requestedTartan = new URLSearchParams(window.location.search).get('tartan');
      if (requestedTartan) {
        var requestedRecord = records.find(function (record) { return record.name === requestedTartan; });
        if (requestedRecord) select(requestedRecord);
      }
    }).catch(function () {
      status.textContent = 'Tartan swatches could not be loaded. Please refresh the page or contact us for help.';
    });
  }

  function start() { document.querySelectorAll('[data-a1-tartan-swatches]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
